import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen, companylogourlset } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Brepingtable1 from '../../component/Brepingtable1';
import Mainbanners from '../../component/Mainbanners';
import MainbannersTable from '../../component/MainbannersTable';

import * as APIS from "../../utils/service";
import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check } from "../../utils/utils";
import consts from '../../libs/consts';
import userEvent from '@testing-library/user-event';


export default function Home({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);

    return(
        <div>
            <div><img src="./images/homeimg1.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg2.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg3.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg4.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg5.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg6.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg7.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg8.png" style={{ width: '100%' }} /></div>
            <div><img src="./images/homeimg9.png" style={{ width: '100%' }} /></div>
            
            <div
                style={{
                    position: 'fixed', left: 0, bottom: 50, width: '100%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}
            >
                <div style={{ width: 400 }}>
                    <Button
                        buttonTxt={'모두의매물 시작하기'}
                        styles={{ 
                        }} 
                        onPress={() => { 
                            navigate('/Login');
                        }}
                    />   
                </div>  
            </div>

            <div className='mainFooter'>
                <div>
                    <Button 
                        buttonTxt={'이용약관'} className={'footerbutton'} 
                        onPress={() => {
                            navigate('/Agree1');
                            // let sender = {
                            //     type: 1
                            // }
                            // APIS.postData('/term', sender).then(({ data }) => {
                            //     //console.log(data);
                            //     const PopComponents = () => {
                            //         return (
                            //             <div 
                            //             dangerouslySetInnerHTML={{__html: data}}
                            //             className='termContetns' 
                            //             />
                                        
                            //         );
                            //     }
                            //     dispatch(
                            //         open({
                            //             component: <PopComponents />,
                            //             title: '서비스 이용 약관',
                            //             titleviewer: true,                 
                            //             alert: false,
                            //         })
                            //     );  
                            // }).catch((e) => {
                            // }).finally(() => {
                            // });                        
                        }}
                    />
                    <span></span>
                    <Button 
                        buttonTxt={'개인정보처리방침'} className={'footerbutton'} 
                        onPress={() => {
                            navigate('/Agree2');
                            // let sender = {
                            //     type: 2
                            // }
                            // APIS.postData('/term', sender).then(({ data }) => {
                            //     //console.log(data);
                            //     const PopComponents = () => {
                            //         return (
                            //             <div 
                            //             dangerouslySetInnerHTML={{__html: data}}
                            //             className='termContetns' 
                            //             />
                                        
                            //         );
                            //     }
                            //     dispatch(
                            //         open({
                            //             component: <PopComponents />,
                            //             title: '개인정보처리방침',
                            //             titleviewer: true,                 
                            //             alert: false,
                            //         })
                            //     );  
                            // }).catch((e) => {
                            // }).finally(() => {
                            // });                        
                        }}                    
                    />
                    <span></span>
                    <Button 
                        buttonTxt={'고객센터'} className={'footerbutton'} 
                        onPress={() => {
                            navigate('/Noticelist');
                        }}
                    />
                </div>
                <div>
                    {/* <p>㈜모두의 매물</p> */}
                    <p style={{ fontSize: 14 }}>에이피링스 주식회사</p>
                    <p>{configdata?.footer?.addr}</p>
                    <p>대표 : {configdata?.footer?.ceo}   사업자등록번호 : {configdata?.footer?.buisness_num}</p>
                    {/* <p>전화번호: 02-0000-0000   |  대표메일:  ymetm-s2000@hanmail.net</p> */}
                    <p>대표메일:  {configdata?.footer?.email}</p>
                    <p>Copyright 에이피링스 주식회사 LTD All Rights Reserved.</p>
                    <div>
                        <Button titleimgs={'./images/icons/Frame1897.svg'} className={'notcss'} />
                        <Button titleimgs={'./images/icons/Frame1898.svg'} className={'notcss'} />
                        <Button titleimgs={'./images/icons/Frame1899.svg'} className={'notcss'} />
                    </div>
                </div>
            </div>            
        </div>
    )
}
